/**
 * Per-week price, which is how the case for a longer plan reads best.
 *
 * This file used to carry a hardcoded table of USD prices "until the pricing
 * endpoint exists". It never needed to: `/user/payment/payment-options` is
 * what the booking flow and the paywall already price from, it is authenticated
 * — which onboarding is by the time it reaches the offer — and it returns the
 * user's own currency with any referral or coupon applied. The placeholders
 * were dollars for everyone, which is a refund request waiting to happen.
 */

export interface WeeklyPriceable {
  price: number;
  /** Billing period. Absent or 0 means a single seat, not a subscription. */
  interval_months?: number;
}

export function weeklyEquivalent(plan: WeeklyPriceable): number | null {
  const months = plan.interval_months ?? 0;
  if (months <= 0) return null;
  // 52 weeks / 12 months.
  return Math.round(plan.price / (months * 4.345));
}
